import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { auth, db } from "../../firebase/config";
import { doc, getDoc } from "firebase/firestore";

const DeliveryPartnerRejected = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (u) => {
      if (u) {
        setUser(u);
        // Check user status in Firestore
        try {
          const docRef = doc(db, "users", u.uid);
          const docSnap = await getDoc(docRef);
          
          if (docSnap.exists()) {
            const data = docSnap.data();
            setUserData(data);
            
            // If approved, redirect to dashboard
            if (data.status === "approved") {
              localStorage.setItem("deliveryPartner", JSON.stringify(data));
              navigate("/partner/dashboard");
              return;
            }
            
            // If pending, redirect to pending page
            if (data.status === "pending") {
              navigate("/delivery-partner/pending");
              return;
            }
          }
        } catch (error) {
          console.error("Error checking user status:", error);
        }
      } else {
        navigate("/delivery-partner/login");
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, [navigate]);

  const handleLogout = async () => {
    try {
      await auth.signOut();
      navigate("/delivery-partner/login");
    } catch (error) {
      console.error("Error signing out:", error);
    }
  };

  const handleContactSupport = () => {
    // You can implement this to open contact form or redirect to support page
    alert("Please contact support at support@jrhomemadefoods.com or call +91-XXXXXXXXXX");
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-green-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-600 mx-auto mb-4"></div>
          <p className="text-green-700 font-medium">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-green-50 flex items-center justify-center px-4">
      <div className="bg-white p-8 rounded-xl shadow-md w-full max-w-md text-center">
        <div className="text-6xl mb-4">❌</div>
        <h2 className="text-2xl font-bold text-red-700 mb-4">
          Registration Rejected
        </h2>
        <p className="text-gray-600 mb-6">
          We're sorry, but your delivery partner application has been rejected by our admin team.
        </p>
        
        {userData && (
          <div className="bg-gray-50 p-4 rounded-lg mb-6 text-left">
            <h3 className="font-semibold text-gray-800 mb-2">Your Details:</h3>
            <p className="text-sm text-gray-600"><strong>Name:</strong> {userData.name}</p>
            <p className="text-sm text-gray-600"><strong>Phone:</strong> {userData.phone}</p>
            <p className="text-sm text-gray-600"><strong>Area:</strong> {userData.area}</p>
            <p className="text-sm text-gray-600"><strong>Status:</strong> 
              <span className="ml-1 px-2 py-1 bg-red-100 text-red-800 rounded-full text-xs">
                Rejected
              </span>
            </p>
          </div>
        )}

        <div className="space-y-4">
          <p className="text-sm text-gray-500">
            Possible reasons for rejection:
          </p>
          <ul className="text-sm text-gray-600 text-left space-y-1">
            <li>• Incomplete or incorrect information provided</li>
            <li>• Invalid documents (Aadhaar, License, RC)</li>
            <li>• Area not currently accepting new partners</li>
            <li>• Background verification issues</li>
          </ul>
          
          <div className="space-y-3 pt-4">
            <button
              onClick={handleContactSupport}
              className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition"
            >
              Contact Support
            </button>
            
            <button
              onClick={handleLogout}
              className="w-full bg-gray-600 text-white py-2 rounded-lg hover:bg-gray-700 transition"
            >
              Sign Out
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeliveryPartnerRejected; 